import React from 'react'
import itemData from './items'

const Categories = () => {
  return (
    <section className="category-section">
        <div className="category-section-title">
            <h2>Categories</h2>
            <div className="category-data">
                <div className="category-data-wrapper">
                    {
                        
                        itemData.map((item, index)=>{
                            const {id, img, title} = item;
                            return<>
                            <div className="category-items" key={id}>
                                <div className="image">
                                    <img src={img} alt={title} />
                                </div>
                                <div className="item-text">
                                    <h2>{title}</h2>
                                </div>
                            </div>
                            </>
                        })
                    }
                </div>
            </div>
        </div>
    </section>
  )
}

export default Categories
